// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"55":"09d665935521cbe2","642":"975882075559d86e","964":"3cf4aa011f6ed22f","987":"b9317c7e417c77de"}[chunkId] + ".js";
};